import React, { useEffect } from 'react';
import AppLayout from '../Layouts/AppLayout/AppLayout';
import { ReactComponent as AccessDenied } from '../../assets/images/access-denied.svg';
import { getTranslation } from '../../utils/translation';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

const HomePage = () => {
    const history = useHistory();
    const isAuthenticated = useSelector(state => state.auth.isAuthenticated);

    useEffect(() => {
        if (isAuthenticated) {
            history.push('/app');
        }
    }, [isAuthenticated]);

    return (
        <AppLayout>
            <div className={'flex justify-center align-center h-full w-full flex-column'}>
                <AccessDenied />
                <span className={'f-s-28'}>{getTranslation('notAuthorized')}</span>
            </div>
        </AppLayout>
    );
};

export default HomePage;
